@if (error(); as error) {
  <div
    class="error {{ variant() }} {{ align() }}"
    [class.f-body-xs]="variant() === 'control'"
    [class.f-medium]="variant() === 'control'"
    [class.f-body-m]="variant() !== 'control'"
    [class.f-body-s]="variant() === 'small'"
  >
    <onyx-icon name="error-filled" [size]="12"></onyx-icon>

    {{ `${I18N}.${error.code}` | translate: error.data }}
  </div>
}
